import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { l_check } from '../../../../icons';
import Icon from '../../Icon';
import { BASE_DEFAULT_PROPS, BASE_PROP_TYPES } from './constants';
import classes from './index.module.scss';

const Option = ({
    children,
    value,
    disabled,
    hidden,
    className,
    // eslint-disable-next-line no-unused-vars
    checkClassName,
    // eslint-disable-next-line no-unused-vars
    checkIconClassName
}) => (
    <option className={className}
        value={value}
        disabled={disabled}
        hidden={hidden}>
        {children}
    </option>
);

Option.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    disabled: PropTypes.bool,
    hidden: PropTypes.bool,
    /**
     * Custom classes you wish to pass to the component.
     */
    className: PropTypes.string,
    /**
     * Custom classes you wish to pass to the check `<Icon/>` wrapper.
     */
    checkClassName: PropTypes.string,
    /**
     * Custom classes you wish to pass to the check `<Icon/>` wrapper.
     */
    checkIconClassName: PropTypes.string
};
Option.defaultProps = { ...BASE_DEFAULT_PROPS };

const OptionWrapper = ({
    children,
    index,
    onChange,
    value,
    selected,
    disabled,
    key,
    className: customClassName,
    checkClassName: customCheckClassName,
    checkIconClassName
}) => {
    const { isTouch } = getContext();
    const Element = isTouch ? 'option' : 'button';
    const className = classnames(
        classes.option,
        customClassName
    );
    const checkClassName = classnames(
        classes.check,
        customCheckClassName
    );

    return (
        <Element onClick={(e) => onChange(e, index)}
            className={className}
            value={value}
            key={key}
            disabled={disabled}>
            {!isTouch && <span className={checkClassName}>
                {selected && (
                    <Icon className={checkIconClassName} size={11}>
                        {l_check}
                    </Icon>
                )}
            </span>}
            {children}
        </Element>
    );
};

OptionWrapper.propTypes = {
    ...BASE_PROP_TYPES,
    index: PropTypes.number.isRequired,
    onChange: PropTypes.func,
    selected: PropTypes.bool,
    key: PropTypes.string
};

OptionWrapper.defaultProps = {
    ...BASE_DEFAULT_PROPS,
    onChange: () => null,
    selected: false
};

export {
    Option,
    OptionWrapper
};
